<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="applause-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-link"></i>
                        拍手ボタン
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mt-3">
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(a, i) in applause" :key="i">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button type="button" class="btn btn-light btn-sm" @click="removeApplause(i)">&times;</button>
                                    </div>
                                    <input type="text" class="form-control applause"
                                        v-model="a.caption"
                                        :maxlength="MAXLENGTH"
                                        :placeholder="placeholder()"
                                        @keydown.enter="addApplause()">
                                    <div class="input-group-append">
                                        <label class="btn btn-light btn-sm m-0 p-2" :class="{active: a.can_review}">
                                            <input type="checkbox" v-model="a.can_review" class="d-none" :true-value="1" :false-value="0" />
                                            <i class="fas fa-check-circle" v-if="a.can_review"></i>
                                            <i class="far fa-circle" v-else></i>
                                            感想可
                                        </label>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="m-3 text-right" v-if="applause.length < MAX">
                            <button type="button" class="btn btn-light btn-sm" @click="addApplause()">
                                <i class="fas fa-plus"></i>
                                追加
                            </button>
                        </div>
                    </div>
                    <div class="small m-3">
                        拍手ボタンを登録します。<br>
                        拍手ボタンは最大{{MAXLENGTH}}文字、最大{{MAX}}個追加することができます。<br>
                        感想可をチェックすると、その拍手ボタンをクリックしたとき、匿名で感想を投稿することができます。<br>
                        ネガティブなボタンの設置はお勧めしません。
                        読者はミスクリックを取り消すことができません。<br>
                        拍手ボタンを削除すると、そのボタンによる拍手もすべて消滅します。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Domain from "components/Domain";
export default {
    components: {
        Domain
    },
    props: {
        book_id: {
            required: true
        }
    },
    data() {
        return {
            applause: [],
            MAX: 5,
            MAXLENGTH: 16
        }
    },
    methods: {
        load() {
            axios.get("/mypage/applause/get", {params: {book_id: this.book_id}}).then(res => {
                this.applause = res.data;
                // 新規追加用
                this.addApplause(true);
            }).catch(err => { alert.err(err.response) });
        },
        addApplause(noFocus = false) {
            if (this.applause.length > 0 &&  !this.applause[this.applause.length - 1].caption) return;
            // 最大数
            if (this.applause.length >= this.MAX) return;
            this.applause.push({
                id: null,
                caption: null,
                order_number: null,
            });
            if (!noFocus) {
                setTimeout(() => { $(".url:last").focus(); });
            }
        },
        removeApplause(i) {
            this.applause.splice(i, 1);
        },
        save() {
            axios.post("/mypage/applause/save", {
                book_id: this.book_id,
                applause: this.applause
            }).then(res => {
                alert.msg("拍手ボタンを保存しました。");
                $("#applause-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        },
        placeholder() {
            const placeholder = [
                "イイね！",
                "読了",
                "面白かった",
                "続きが読みたい",
                "期待しています"
            ];
            return placeholder[Math.floor(Math.random() * 5)];
        },
    },
    computed: {
        placeholderxx() {
            const placeholder = [
                "イイね！",
                "読了",
                "面白かった",
                "続きが読みたい",
                "期待しています"
            ];
            return placeholder[Math.floor(Math.random() * 5)];
        },
    },
    mounted() {
        $("#applause-modal").on("show.bs.modal", (e) => {
            this.load();
            setTimeout(() => { $(".applause:last").focus(); }, 500);
        });
    }
}
</script>